import { ArrowRight } from "lucide-react";
import React from "react";

function Hero({ title, description, image }) {
  return (
    <div className="relative h-[60vh] overflow-hidden bg-[#fef8f5]">
      <img
    className="absolute w-full h-full object-cover"
    src={image}
    alt=""
    style={{
      opacity: 0.4,
      objectFit: "cover",
      mixBlendMode: "multiply",
    }}
  />
      <div className="absolute inset-0 bg-[#fef8f5] opacity-70" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center max-w-3xl px-4">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#7a6e5f] mb-6">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-[#7a6e5f] opacity-80 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hero;
